import { render, staticRenderFns } from "./PacoteServico.vue?vue&type=template&id=67e0cf40&"
import script from "./PacoteServico.vue?vue&type=script&lang=js&"
export * from "./PacoteServico.vue?vue&type=script&lang=js&"
import style0 from "./PacoteServico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports